export function isExternalImage(imagePath) {
    return imagePath.startsWith('http');
}
